import React from 'react'
import { Grid } from '@mui/material'
import { useTranslate } from 'react-admin'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'

export const ServicePackageTab = ({ product, loading }) => {
  const translate = useTranslate()
  
  const productName = "Service Package"
  const rawAmount = product?.service_package_amount ?? "0"
  const currency = product?.currency
  const formattedAmount = `${currency} ${Number(rawAmount).toFixed(2)}`

  return (
    <Grid container spacing={2}>
      <ShowListElement
        sm={2}
        label={translate('ra.field.product')}
        value={productName}
      />
      <ShowListElement
        sm={2}
        label={translate('ra.field.amount')}
        value={loading ? translate('ra.action.loading') : formattedAmount}
      />
    </Grid>
  )
}